module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-15GENNAIO-25-5f079c05676dd4cf3a48f8e1f142ccc6.png";